import {
  ProviderInfo,
  Provider,
  RegionInfo,
  Region,
  ProviderRegionState,
} from 'js/types'

export const findProviderInfo = (
  state: ProviderRegionState,
  provider: Provider
): ProviderInfo => {
  return state.allProviderRegions.providerInfo.find(
    (info) => info.provider == provider
  )
}

export const findRegionInfo = (
  state: ProviderRegionState,
  region: Region
): RegionInfo => {
  const {
    providerInfo: {provider},
  } = state
  return state.allProviderRegions.regionInfo[provider].find(
    (r) => r.provider === provider && r.region === region
  )
}

export const findFirstRegion = (
  state: ProviderRegionState,
  provider: Provider
): RegionInfo => {
  return state.allProviderRegions.regionInfo[provider][0]
}
